import React from 'react';
import * as Backend from "../backend.js";
import * as util from "../other/util.js";
import { Link } from "react-router-dom";
import Exception from "../share/exception.js";

// The leaderboard
class RankingView extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    refreshState() {
        Backend.getRanking(1, (ranking) => {
            this.setState({ ranking: ranking });
        });
    }

    render() {
        if (!this.hasCurrentState()) {
            return (<util.LoadingBar2 />);
        }

        const ranking_type = this.props.params.ranking_type;
        const ranking = this._getRanking(ranking_type);

        if (!ranking) {
            return (
                <div className="fade-in">
                    <h1>Leaderboard</h1>
                    <p>Invalid ranking type: {ranking_type}</p>
                </div>
            );
        }

        return (
            <div className="fade-in" key={Math.random()}>
                <h1>Leaderboard</h1>
                <div>
                    {this._renderLinkToSubPage("overall", "Overall")}
                    {this._renderLinkToSubPage("planet", "Buildings")}
                    {this._renderLinkToSubPage("research", "Research")}
                </div>
                <table className="generic-list">
                    <thead style={{ fontSize: "14px" }}>
                        <tr>
                            <td>Rank</td>
                            <td>Player</td>
                            <td>Points</td>
                        </tr>
                    </thead>
                    <tbody>
                        {ranking.map((player, idx) => this._renderPlayer(player, idx, ranking_type))}
                    </tbody>
                </table>
                <br />
                <util.JsonDebug obj={ranking} />
            </div>
        );
    }

    _getRanking(ranking_type) {
        switch (ranking_type) {
            case "overall":
                return this.state.ranking.players;
            case "planet":
                return this.state.ranking.planet_players;
            case "research":
                return this.state.ranking.research_players;
            default:
                return null;
        }
    }

    _getPoints(player, ranking_type) {
        switch (ranking_type) {
            case "overall":
                return player.points;
            case "planet":
                return player.planet_points;
            case "research":
                return player.research_points;
            default:
                throw new Exception("no such ranking");
        }
    }

    _renderPlayer(player, idx, ranking_type) {
        return (
            <tr key={player.id}>
                <td>{idx + 1}</td>
                <td>
                    <util.PlayerLink playerId={player.id} playerName={player.name} />
                </td>
                <td>{this._getPoints(player, ranking_type)}</td>
            </tr>
        );
    }

    _renderLinkToSubPage(page_url, page_name) {
        const active_page = this.props.params.ranking_type;
        const url = '/game/ranking/' + page_url;
        if (page_url === active_page) {
            return (<Link className="link-button-menu" to={{ pathname: url, force_update: true }}>&gt;&gt; {page_name} &lt;&lt;</Link>);
        } else {
            return (<Link className="link-button-menu" to={{ pathname: url, force_update: true }}>{page_name}</Link>);
        }
    }
}

export default util.withParamsAndNavigation(RankingView);
